import styled from 'styled-components';
import { motion as Motion } from 'framer-motion';

export const ScrollIndicator__Label = styled(Motion.label)`
    opacity: 0;
`;
